import React, { Component } from 'react';
import {Drawer, List, Divider} from '@material-ui/core';
import DehazeIcon from '@material-ui/icons/Dehaze';
import ClearIcon from '@material-ui/icons/Clear';
import Logo from '../../img/headerLogo.png';
import Logo_JRA from '../../img/JRA_Subsidy.png';
import i18n from '../../i18n'


class MobileHeader extends Component{

  constructor(props){
    super(props)
    this.state = {
      open:false,
      padding:0
    }
  }

  showDrawer=()=>{
    this.setState({open:true})
  }

  closeDrawer=()=>{
    this.setState({open:false})
  }

  componentWillMount=()=>{
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  handleResize=()=>{
      //レスポンシブデザイン
      var windowWidth = window.innerWidth
      var textWidth = 367
      var liPaddingWidth = (windowWidth - textWidth) / 2
      var padding = "20px" + " " + liPaddingWidth + "px"
      this.setState({padding:padding})
  }

  render(){
    return(
        <div id={"header"} style={styles.header}>
          <div className={"title"}>
            <a href="/">
              <img src={Logo} style={styles.logo}></img>
              <img src={Logo_JRA} style={styles.logoJRA}></img>
            </a>
            <DehazeIcon style={styles.dehazeIcon} onClick={this.showDrawer}/>
            <Drawer
              variant="persistent"
              anchor="right"
              open={this.state.open}
            >
              <ClearIcon style={styles.ClearIcon} onClick={this.closeDrawer}/>
              <List>
                <ul style={styles.ul}>
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.home')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#introduction" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.about_process')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#about_blockchain" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.blockchain')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#about_coin" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.coin')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/stores/" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.stores')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/restaurants/" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.restaurants')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#about_cultivation" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.about_cultivation')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#contact_us" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.contact_us')}</a></li>
                  <Divider />
                  <li style={{marginRight:"5px", overflow:"hidden", fontSize:"40px", padding:this.state.padding, textAlign:"center"}}><a href="/#partners" style={styles.a} onClick={this.closeDrawer}>{i18n.t('header.partners')}</a></li>
                </ul>
              </List>
            </Drawer>
        </div>
      </div>
  );
  }
}

const styles = {
  header:{
    height:"130px",
    width:"100%"
  },
  logo:{
    position:"absolute",
    left:"5%",
    width:"80%",
    top:"15px"
  },
  logoJRA:{
    position:"absolute",
    left:"70%",
    top:"35px",
    width:"104px",
    height:"70px",
  },
  dehazeIcon:{
    fontSize:"60px",
    position:"absolute",
    right:"7%",
    top:"30px"
  },
  ClearIcon:{
    fontSize:"80px",
    position:"relative",
    left:"86%",
    top:"30px"
  },
  ul:{
    marginTop:"15%",
  },
}

export default MobileHeader;